import { CallFlowVoiceOption } from "@/model/interface/CallFlow";

export const DEFAULT_VOICE = "Polly.Joanna";

export const VOICE_OPTIONS: CallFlowVoiceOption[] = [
  { value: "Polly.Joanna", label: "Joanna (US, female)", language: "en-US" },
  { value: "Polly.Joanna-Neural", label: "Joanna Neural (US, female)", language: "en-US" },
  { value: "Polly.Matthew", label: "Matthew (US, male)", language: "en-US" },
  { value: "Polly.Matthew-Neural", label: "Matthew Neural (US, male)", language: "en-US" },
  { value: "Polly.Salli", label: "Salli (US, female)", language: "en-US" },
  { value: "Polly.Joey", label: "Joey (US, male)", language: "en-US" },
  { value: "Polly.Kimberly", label: "Kimberly (US, female)", language: "en-US" },
  { value: "Polly.Kendra", label: "Kendra (US, female)", language: "en-US" },
  { value: "Polly.Amy", label: "Amy (UK, female)", language: "en-GB" },
  { value: "Polly.Amy-Neural", label: "Amy Neural (UK, female)", language: "en-GB" },
  { value: "Polly.Brian", label: "Brian (UK, male)", language: "en-GB" },
  { value: "Polly.Nicole", label: "Nicole (AU, female)", language: "en-AU" },
  { value: "Polly.Russell", label: "Russell (AU, male)", language: "en-AU" },
];
